<div class="custom-toolbar">
  <div class="custom-toolbar-element custom-toolbar-subdivision-left">
    <!--
    <div class="d-flex flex-rowa align-items-center">
      <span class="mg-r-5 ">
          <p-selectButton [options]="startPoints" (onChange)="updateStartPoint()"
                          [(ngModel)]="startPoint"></p-selectButton>
        </span>
    </div>
    -->

    <!-- *ngIf="startPoint === StartPointCommandesClientsEnum.PLC" -->
    <yo-lookup
      id="plc-look-up"
      [data]="mplc.plcList"
      [selectedItem]="selectedPlc"
      (onValueChange)="selectStartPoint($event)"
      [showClearButton]="true"
      [width]="250"
      [key]="null"
      enableSearch="true"
      placeholder="Sélectionner un point de livraison"
    >
    </yo-lookup>

    <!--<dx-select-box *ngIf="startPoint === StartPointCommandesClientsEnum.REPAS"
     [dataSource]="mplc.repasList"
     placeholder="Sélectionner un repas..."
     displayExpr="libelle"
     (onValueChanged)="selectStartPoint($event)"
     [searchExpr]="searchExprOption"
     [minSearchLength]="0"
     [searchEnabled]="true"
     [value]="selectedRepas"
     [showClearButton]="true"
     [(ngModel)]="selectedRepas">
   </dx-select-box>

   <dx-select-box *ngIf="startPoint === StartPointCommandesClientsEnum.PRESTATION"
     [dataSource]="mplc.prestationList"
     placeholder="Sélectionner une prestation/un régime..."
     displayExpr="libelle"
     (onValueChanged)="selectStartPoint($event)"
     [searchExpr]="searchExprOption"
     [minSearchLength]="0"
     [searchEnabled]="true"
     [showClearButton]="true"
     [value]="selectedPrestation"
     [(ngModel)]="selectedPrestation">
   </dx-select-box> -->
  </div>
  <div class="custom-button-container-right">
    <yo-button
      iconClass="fas fa-save"
      buttonClass="cta-success"
      (onClick)="saveEffectivesCommandesClients()"
      [disabled]="isDisabled()"
      tooltip="Enregistrer les effectifs">
    </yo-button>
    <yo-button
      iconClass="fas fa-print"
      [disabled]="isDisabled()"
      (onClick)="printMenu.toggle($event)"
      tooltip="Impression">
    </yo-button>
    <yo-button
      iconClass="fas fa-copy"
      [disabled]="isDisabled()"
      (onClick)="openDialogDuplicateEffectivesPrevisionnals()"
      tooltip="Dupliquer les effectifs">
    </yo-button>
  </div>
</div>
<p-menu appendTo="body" #printMenu [popup]="true" [model]="itemsPrintMenu"></p-menu>

<dx-toolbar class="p-4">
  <dxi-item location="before">
    <div class="d-flex flex-row align-items-center">
      <!--        CALENDRIER-->
      <span class="mg-r-5">
        <dx-date-box
          [disabled]="isDatesDisabled()"
          [(value)]="selectedDate"
          [applyValueMode]="'instantly'"
          (onValueChanged)="updateDatesBySelection($event)"
          [calendarOptions]="calendarOptions"
          (onFocusOut)="updtateDatesByClickOutside()"
        >
          <span *dxTemplate="let cell of 'cell'">
            <yo-devextreme-date-dispo [cellData]="cell"
                                      [dateFacturation]="utils.isDateInList(convertToDate(cell.date), datesFacturation)"
                                      [dateSaisieEffectif]="utils.isDateInList(convertToDate(cell.date), datesSaisieEffectifs)"
                                      [dateCreationMenu]="utils.isDateInList(convertToDate(cell.date), datesCreationMenus)"></yo-devextreme-date-dispo>
          </span>
        </dx-date-box>
        </span>
    </div>
  </dxi-item>

  <dxi-item location="center">
    <div class="d-flex flex-rowa align-items-center">
      <!--        TYPE D'EFFECTIF-->
      <span class="mg-r-5 ">
          <p-selectButton [options]="modes" (onChange)="changeTypeEffectif()"
                          [disabled]="isDisabled()"
                          [(ngModel)]="typeEffectifSelected"></p-selectButton>
        </span>
    </div>
  </dxi-item>
</dx-toolbar>

<div class="d-flex mg-t-14 flex-wrap container-table" style="overflow-y: scroll">

  <div class="left">

    <dx-tabs
      *ngIf="endPointPanel.length > 0 && idSelected && viewCommandesEffectifs != null"
      [selectedItem]="endPoint"
      [dataSource]="endPointPanel"
      (onItemClick)="updateEndPoint($event)"
    ></dx-tabs>
    <div id="sub-left">
      <yo-plc-semaine *ngIf="startPoint === StartPointCommandesClientsEnum.PLC" [datesFacturation]="datesFacturation" [selectedCell]="selectedCell"
                      [endPoint]="endPoint" [cols]="cols" [typeEffectif]="typeEffectifSelected"></yo-plc-semaine>
      <yo-prestations-semaine *ngIf="startPoint === StartPointCommandesClientsEnum.PRESTATION" [selectedCell]="selectedCell"
                              [endPoint]="endPoint" [cols]="cols" [datesFacturation]="datesFacturation"
                              [typeEffectif]="typeEffectifSelected"></yo-prestations-semaine>
      <yo-repas-semaine *ngIf="startPoint === StartPointCommandesClientsEnum.REPAS" [datesFacturation]="datesFacturation" [selectedCell]="selectedCell"
                        [endPoint]="endPoint" [cols]="cols" [typeEffectif]="typeEffectifSelected"></yo-repas-semaine>
    </div>
    <div class="card-footer mg-t-14">
          <span class="font-weight-normal font-12">
            <div class="text-left">
              <i class="fas fa-square save-color mg-r-5 border"></i>Effectifs en cours de saisie
            </div>
            <div class="text-left">
              <i class="fas fa-square import-color mg-r-5 border"></i>Effectifs importés
            </div>
            <div class="text-left">
              <i class="fas fa-square site-secondaire-color mg-r-5 border"></i>Menus en cours de saisie
            </div>
            <div class="text-left">
              <i class="fas fa-square checked-color mg-r-5 border"></i>Menus validés = Saisie des effectifs possible
            </div>
            <div class="text-left">
              <i class="fas fa-square invoice-color mg-r-5 border"></i>Effectifs faisant l'objet d'une facture
            </div>
            <div class="text-left">
              <i class="fas fa-square white mg-r-5 border"></i>Aucun menu
            </div>
          </span>
    </div>
  </div>

  <div class="right">
    <yo-repas [datesFacturation]="datesFacturation"></yo-repas>
  </div>
</div>

<!--IMPRESSION DES EFFECTIFS-->
<yo-print-effectif></yo-print-effectif>
<yo-print-cout-revient-plat></yo-print-cout-revient-plat>
<yo-print-effectif-totaux></yo-print-effectif-totaux>

<dx-popup
  [showTitle]="true"
  width="650px"
  [height]="'auto'"
  title="Dupliquer les effectifs"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [(visible)]="popupDuplicateEffectivesVisible"
>
  <div class="dialog-line">
    <!-- <div class="row">
      <div class="col-md-8">
        <dx-tag-box
          [dataSource]="mplc.plcList"
          placeholder="Sélectionner un ou plusieurs points de livraison..."
          displayExpr="libelle"
          valueExpr="id"
          [(ngModel)]="selectedPlcListForDuplication"
          [searchExpr]="searchExprOption"
          [searchEnabled]="true"
          [minSearchLength]="0"
          [showClearButton]="true"
          (onValueChanged)="selectPlcForDuplication($event)"
        >
        </dx-tag-box>

      </div>
    </div> -->
    <div class="row">
      <div class="col-md-6">
        <dx-select-box
          [dataSource]="modesSource"
          displayExpr="label"
          valueExpr="value"
          [value]="typeEffectifSource"
          (onValueChanged)="changeTypeEffectifSource($event)">
        </dx-select-box>
      </div>
      <div class="col-md-6">
        <dx-tag-box
          [dataSource]="modesFiltered"
          displayExpr="label"
          valueExpr="value"
          [(value)]="typesEffectifTarget"
          (onValueChanged)="changeTypeEffectifTarget($event)"
          [showSelectionControls]="true"
          [applyValueMode]="'useButtons'"
          [searchEnabled]="true">
        </dx-tag-box>

      </div>
    </div>
  </div>
  <div class="dialog-line">
    <div class="custom-button-container-right">
      <yo-button
        label="Dupliquer"
        iconClass="fas fa-copy"
        class="mg-r-5 va-top"
        (onClick)="duplicateEffectives()"
        tooltip="Copier">
      </yo-button>
      <yo-button
        label="Fermer"
        iconClass="fas fa-times"
        buttonClass="cta-inner-delete"
        (onClick)="closeDialogDuplicateEffectivesPrevisionnals()">
      </yo-button>
    </div>
  </div>
</dx-popup>

<dx-load-panel
  #loadPanel
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
>
</dx-load-panel>

